/* ============================================
   CUSTOM PRODUCT TABS JAVASCRIPT
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  const tabsContainer = document.querySelector('.custom-product-tabs');
  
  if (!tabsContainer) return;
  
  const contentContainer = tabsContainer.querySelector('.custom-product-tabs__content');
  let tabPanels = tabsContainer.querySelectorAll('.custom-product-tabs__panel');
  
  // Move nested panels to be siblings
  if (contentContainer && tabPanels.length > 0) {
    const allPanels = Array.from(tabPanels);
    allPanels.forEach((panel, index) => {
      if (index > 0) {
        contentContainer.appendChild(panel);
      }
    });
    tabPanels = tabsContainer.querySelectorAll('.custom-product-tabs__panel');
  }
  
  const tabButtons = tabsContainer.querySelectorAll('.custom-product-tabs__button');
  const isMobile = window.innerWidth <= 767;
  
  if (isMobile) {
    setupMobileAccordion();
    setTimeout(() => setupReadMore(), 200);
  } else {
    setupDesktopTabs();
    setupReadMore();
  }
  
  // Reinitialize on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const nowMobile = window.innerWidth <= 767;
      if (nowMobile !== isMobile) {
        location.reload();
      }
    }, 250);
  });
  
  function setupMobileAccordion() {
    tabPanels.forEach((panel, index) => {
      const button = tabButtons[index];
      if (button && panel) {
        const accordionButton = button.cloneNode(true);
        accordionButton.classList.remove('active');
        panel.insertBefore(accordionButton, panel.firstChild);
        
        if (index === 0) {
          accordionButton.classList.add('active');
        }
        
        accordionButton.addEventListener('click', function(e) {
          e.preventDefault();
          const isActive = panel.classList.contains('active');
          
          tabPanels.forEach(p => {
            p.classList.remove('active');
            const btn = p.querySelector('.custom-product-tabs__button');
            if (btn) btn.classList.remove('active');
          });
          
          if (!isActive) {
            panel.classList.add('active');
            accordionButton.classList.add('active');
            
            // Scroll to the top of the panel when opening on mobile
            setTimeout(() => {
              const yOffset = -180; // Offset to account for sticky header
              const element = panel;
              const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
              
              window.scrollTo({ top: y, behavior: 'smooth' });
            }, 1);
          }
        });
      }
    });
    
    tabPanels.forEach((panel, index) => {
      if (index !== 0) {
        panel.classList.remove('active');
      }
    });
  }
  
  function setupDesktopTabs() {
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanels.forEach(panel => panel.classList.remove('active'));
        
        this.classList.add('active');
        const targetPanel = document.getElementById(targetTab);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  }
  
  function setupReadMore() {
    const allPanels = document.querySelectorAll('.custom-product-tabs__panel');
    
    allPanels.forEach((panel) => {
      const rte = panel.querySelector('.rte');
      if (!rte || rte.querySelector('.custom-product-tabs__panel-content')) return;
      
      const contentWrapper = document.createElement('div');
      contentWrapper.className = 'custom-product-tabs__panel-content';
      
      while (rte.firstChild) {
        contentWrapper.appendChild(rte.firstChild);
      }
      rte.appendChild(contentWrapper);
      
      // Temporarily show to measure height
      const originalDisplay = rte.style.display;
      rte.style.display = 'block';
      rte.style.visibility = 'hidden';
      rte.style.position = 'absolute';
      
      const contentHeight = contentWrapper.scrollHeight;
      
      rte.style.display = originalDisplay;
      rte.style.visibility = '';
      rte.style.position = '';
      
      const heightThreshold = 300;
      
      if (contentHeight > heightThreshold) {
        contentWrapper.classList.add('collapsed');
        
        const readMoreBtn = document.createElement('button');
        readMoreBtn.className = 'custom-product-tabs__read-more';
        readMoreBtn.innerHTML = `
          Read More
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        `;
        
        rte.appendChild(readMoreBtn);
        
        readMoreBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isCollapsed = contentWrapper.classList.contains('collapsed');
          
          if (isCollapsed) {
            contentWrapper.classList.remove('collapsed');
            readMoreBtn.classList.add('expanded');
            readMoreBtn.innerHTML = `
              Read Less
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            `;
          } else {
            contentWrapper.classList.add('collapsed');
            readMoreBtn.classList.remove('expanded');
            readMoreBtn.innerHTML = `
              Read More
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            `;
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }
    });
  }
});
